export const AUTH_CONFIG = {
  clientId: process.env.REACT_APP_MSAD_CLIENTID,
  callbackUrl: process.env.REACT_APP_CALLBACK,
  TENANT: process.env.REACT_APP_AD_TENANT,
  CLIENT_ID: process.env.REACT_APP_AD_APP_ID,
};
